"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transformer = void 0;
class Transformer {
    transform(message) {
        return this.transformation(message);
    }
}
exports.Transformer = Transformer;
//# sourceMappingURL=transformer.js.map